"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
const React = __importStar(require("react"));
const Carousel_styled_1 = require("./Carousel.styled");
// TODO: This wasn't originally written for Emotion styles and was copied wholesale
//       out of a prototypical PropertyDashboard originally in the Portal.
// 		 Styles may need some Emotional support.
const useMediaQuery = (query) => {
    const matcher = window.matchMedia(query);
    const [match, setMatch] = React.useState(matcher.matches);
    const callback = (event) => setMatch(event.matches);
    React.useEffect(() => {
        matcher.addListener(callback);
        return () => {
            matcher.removeListener(callback);
        };
    }, []);
    return match;
};
const Carousel = ({ query, itemWidth, children }) => {
    const mobile = query ? useMediaQuery(query) : true;
    if (!mobile || typeof children !== 'object')
        return React.createElement(React.Fragment, null, children);
    const keys = Object.keys(children || {});
    return (React.createElement(Carousel_styled_1.StyledCarousel, null,
        React.createElement("div", { className: "carousel-scroller" },
            React.createElement("div", { className: "carousel-inner", style: {
                    width: (itemWidth + 20) * keys.length - 20 + 'px',
                } }, keys.map((key, idx) => (React.createElement("div", { className: "carousel-item", key: `carousel-item-${idx}`, style: { width: `${itemWidth}px` } }, children[key])))))));
};
exports.Carousel = Carousel;
//# sourceMappingURL=Carousel.js.map